module.exports = __webpack_public_path__ + "static/img/merchant_case_6.cf0a002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_6.png
// module id = /b9y
// module chunks = 8